import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import CertificatesMain from './CertificatesMain';

const Certificates = () => {
  return (
    <>
      <HeaderSeven />
      <CertificatesMain />
      <Footer />
    </>
  );
};

export default Certificates;
